import { render } from "./FaqAccordion.vue?vue&type=template&id=1a1e7cb7&scoped=true"
import script from "./FaqAccordion.vue?vue&type=script&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&lang=js"

import "./FaqAccordion.vue?vue&type=style&index=0&id=1a1e7cb7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1e7cb7"]])

export default __exports__